import { State } from '../reducers/rootReducer'
import Visualization from '../../entities/Visualization'

const visualizationSelector = (state: State): Visualization => state.visualization

export default visualizationSelector
